/**
 *机构管理接口地址
 *@author xujinjiang
 *@date 2022/3/3 9:33
 */
import { UrlConfig } from '@/config/UrlConfig';
export class InstitutionUrlConfig {
  // 获取机构列表
  public static getInstitutionList = `${UrlConfig.websiteBaseurl}/thirdparty/developer/organization`;

  // 新增机构
  public static addInstitution = `${UrlConfig.websiteBaseurl}/thirdparty/developer/organization`;
  // 修改机构
  public static modifyInstitution = `${UrlConfig.websiteBaseurl}/thirdparty/developer/organization/modify`;
  // 获取省
  public static getProvinceInfo = `${UrlConfig.websiteBaseurl}/base/region/province`;
  // 获取市
  public static getCityInfo = `${UrlConfig.websiteBaseurl}/base/region/city`;
  // 获取区
  public static getDistrictInfo = `${UrlConfig.websiteBaseurl}/base/region/district`;
}
